import Card, { CardHeader } from "components/card";
import { InputField, Select, Textarea } from "components/fields";

const STATUS_OPTIONS = [
  { value: "draft", label: "Draft" },
  { value: "active", label: "Active" },
  { value: "inactive", label: "Inactive" },
];

const DetailsSection = ({ editor }) => {
  const { formData, errors, handleChange } = editor;

  return (
    <div className="flex flex-col gap-5">
      <Card padding="md" className="gap-4">
        <CardHeader
          title="Campaign Details"
          description="Internal settings for your team. Respondents don't see these."
        />
        <InputField
          label="Campaign Name"
          required
          value={formData.name}
          onChange={(e) => handleChange("name", e.target.value)}
          placeholder="e.g., First-Time Visitor Survey"
          error={errors.name}
        />
        <Textarea
          label="Internal Description"
          rows={2}
          value={formData.description}
          onChange={(e) => handleChange("description", e.target.value)}
          placeholder="Internal notes about this campaign (not shown to respondents)..."
          hint="This is for internal reference only and won't be shown to survey respondents."
        />
        <Select
          label="Status"
          value={formData.status}
          onChange={(e) => handleChange("status", e.target.value)}
          options={STATUS_OPTIONS}
        />
      </Card>

      <Card padding="md" className="gap-4">
        <CardHeader
          title="Survey Respondent Experience"
          description="The fields below will be visible to people taking the survey."
        />
        <Textarea
          label="Welcome Message"
          rows={3}
          value={formData.welcomeMessage}
          onChange={(e) => handleChange("welcomeMessage", e.target.value)}
          placeholder="Welcome! We're so glad you're here. This quick survey helps us better serve you and our community..."
          hint="This message appears at the top of the survey to greet respondents."
        />
        <Textarea
          label="Survey Description"
          rows={2}
          value={formData.surveyDescription}
          onChange={(e) => handleChange("surveyDescription", e.target.value)}
          placeholder="A brief description of what this survey is about and how responses will be used..."
          hint="Brief context shown below the welcome message."
        />
      </Card>
    </div>
  );
};

export default DetailsSection;
